import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CheckinStandbyReviewSubHeaderComponent } from './checkin-standby-review-sub-header.component';
import { RouterModule } from '@angular/router';
import { StaticMsgModule } from '@lib/pipes';
import { IfScreenSizeModule } from '@common/directives/if-screen-size/if-screen-size.module';

@NgModule({
  declarations: [CheckinStandbyReviewSubHeaderComponent],
  imports: [CommonModule, IfScreenSizeModule, RouterModule, StaticMsgModule],
  exports: [CheckinStandbyReviewSubHeaderComponent],
})
export class CheckinStandbyReviewSubHeaderModule {}
